export default __webpack_public_path__ + "static/media/aoi.94637cbf.jpg";